import {API_GATEWAY_BASE_URL, getGatewayAuthHeader} from "../gatewayConfig";

export type QualifyingLadderEntry = {
    driver_id: number;
    driver_name: string;
    position: number;
    best_et: number;
    best_mph: number;
    drbb_id: number;
};

export type QualifyingLadderResponse = {
    status: string;
    data: {
        ladder: QualifyingLadderEntry[];
        event: number;
        category: number;
        round: number | null;
        round_runs: unknown[];
        count: number;
        timestamp: string;
    };
};

export async function fetchQualifyingLadderByEventName(eventName: string, category: number): Promise<QualifyingLadderResponse> {
    if (!API_GATEWAY_BASE_URL) {
        throw new Error("API_GATEWAY_BASE_URL is not defined in environment.");
    }

    const url = new URL("/api/v1/ladder/qualifying/by-event-name", API_GATEWAY_BASE_URL);
    url.searchParams.set("event_name", eventName);
    url.searchParams.set("category", String(category));

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            ...getGatewayAuthHeader(),
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch qualifying ladder: ${response.status} ${response.statusText}`);
    }

    const data = await response.json() as QualifyingLadderResponse;
    console.log(data);

    if (data.status !== "success") {
        throw new Error("Qualifying ladder response did not indicate success.");
    }

    return data;
}

